/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { TFunction } from '@scuf/localization/dist/types';
import descriptors from '../../../locales/en-US/descriptors';
import { IUtilityCostSavingsData } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { UtilityCostData } from '../../DetailKPIWidgets/UtilityBillViewDetailsComponent/IUtilityBillViewDetails';
import { IDataTableHeader } from '../BreakdownByMeter/BreakdownByMeterProps';
import {
  KPI_PERCENTAGE_DECIMAL_PRECISION,
  PERCENT_CHANGE_THRESHOLD
} from './Constants';

const d = descriptors.energyManagement;

export const convertDataForAllUtilityCostSavingsSite = (
  breakdownBySite: UtilityCostData[] | undefined,
  showChangeWhenData: boolean = false
) => {
  let siteSavingsData: IUtilityCostSavingsData[] = [];
  breakdownBySite?.forEach((data) => {
    const { siteName, aggregations, siteId } = data;
    const savingPercent =
      showChangeWhenData &&
      (isNaN(Number(aggregations.totalActualCost)) ||
        isNaN(Number(aggregations.previousPeriodCost)) ||
        Number(aggregations.totalActualCost) === 0 ||
        Number(aggregations.previousPeriodCost) === 0 ||
        !data.isCompleted ||
        Math.abs(Number(aggregations.totalCostSavingsPercentage)) >
          PERCENT_CHANGE_THRESHOLD);
    const siteSavings: IUtilityCostSavingsData = {
      siteName,
      siteId,
      totalActualCost: aggregations.totalActualCost,
      previousPeriodCost: aggregations.previousPeriodCost,
      costSavings: savingPercent ? null : aggregations.totalCostSavings,
      savingsPercentage: parseFloat(
        aggregations.totalCostSavingsPercentage.toFixed(
          KPI_PERCENTAGE_DECIMAL_PRECISION
        )
      )
    };
    siteSavingsData.push(siteSavings);
  });

  let maxRelativeValue = Number.MIN_VALUE;
  siteSavingsData.forEach((site: IUtilityCostSavingsData) => {
    let tempMax = site.previousPeriodCost;
    if ((site.totalActualCost || 0) > (site.previousPeriodCost || 0)) {
      tempMax = site.totalActualCost;
    }
    if ((tempMax || 0) > maxRelativeValue) {
      maxRelativeValue = tempMax || 0;
    }
  });
  siteSavingsData = siteSavingsData.map((sitedata: IUtilityCostSavingsData) => {
    return {
      progessBarRelativeWidth: maxRelativeValue,
      ...sitedata
    };
  });
  return siteSavingsData;
};

export const getUtilityTableHeader = (t: TFunction) => {
  return [
    {
      HeaderValue: t(d.breakdownUtility),
      TextAlignValue: 'left',
      Field: 'Type'
    },
    {
      HeaderValue: t(d.ActualCost),
      TextAlignValue: 'right',
      Field: 'TotalActualCost'
    },
    {
      HeaderValue: t(d.CostPercentage),
      TextAlignValue: 'right',
      Field: 'TotalActualCostPercentage'
    }
  ] as IDataTableHeader[];
};
export const isLoadingCheck = (isLoading: boolean, t: TFunction) =>
  isLoading ? `${t(d.LOADING)}...` : `${t(d.NORESULTS)}`;
